import React, { Component } from "react";
import styled from "styled-components";
import { LabelDollarFormatted, LabelString, TableDefault } from "@loanbossinc/component-library";

const StyledWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .table-wrapper {
    box-shadow: none;
    border-radius: 0;
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }
`;

const StyledTable = styled(TableDefault)`
  && {
    table thead tr th {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #5F6368;
    }
  }
`;

export const StyledLabelString = styled(LabelString)`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
`;

export const StyledLabelDollarFormatted = styled(LabelDollarFormatted)`
  && {
    float: right;
  }
`;

export class StyledBaseTable extends Component {
  render() {
    const { items, columns, onRowClick } = this.props;

    return (
      <StyledWrapper>
        <StyledTable
          className="table-wrapper"
          columns={columns}
          items={items}
          onRowClick={onRowClick}
          noDataMessage="No Properties Found"
        />
      </StyledWrapper>
    );
  }
}
